import React, {useMemo} from 'react'
import './proposals.css'
import axios from 'axios'
import { baseUrl } from '../assets/Animations'
import { FilterTypeId } from '../SearchHeader/filters-type';
import { format } from 'date-fns'
import { getRequestHeaders } from '../api'
import SearchHeader from '../SearchHeader/SearchHeader'

const Proposals = ({userData}) => {
    const [proposals, setProposals] = React.useState([])
    const [filteredProposals, setFilteredProposals] = React.useState([])
    const [families, setFamilies] = React.useState([])
    const [schools, setSchools] = React.useState([])
    const [filterState, setFilterState] = React.useState({});

    const isManager = userData.PermissionLevel === 'manager' && userData.IsAdmin

    React.useEffect(() => {
        axios.get(`${baseUrl}/invitations`)
        .then(res => setProposals(sortProposalsByDate(res.data)))
        .catch(err => console.log(err))
        axios.get(`${baseUrl}/school-management`, getRequestHeaders())
        .then(res => setFamilies(res.data))
        .catch(err => console.log(err))
        makeCalls()
        isManager && setFilterState({school: userData.School})
    }, [])

    React.useEffect(() => {
        filterProposals(proposals)
    }, [filterState])

    const filterProposals = (proposals) => {
        let filtered = []
        filtered = proposals.filter(proposal => {
            if(filterState.school && filterState.school !== 'all' && filterState.school !== proposal.school) {
                return false;
            }
            return true;
        })
        setFilteredProposals(filtered)
    }


    const makeCalls = async () => {
        let schoolOptions = [{id: 'all', label: 'All Schools'}]
        const schoolsReturn = await getSchools();
        schoolsReturn.data.forEach(school => {
            schoolOptions.push({ id: school.schoolAbbreviation.toLocaleLowerCase(), label: school.name.split(' ')[0] });
          })
        setSchools(schoolOptions);
    }

    const getSchools = () => axios.get(`${baseUrl}/schools`)

    const getFamilyName = (familyId) => {
        const family = families.find(family => family.familyId === familyId)
        return family?.familyName ? family.familyName : 'Deleted Family'
    }

    const sortProposalsByDate = (proposals) => {
        return proposals.sort((a, b) => {
            return new Date(b.dateInvited) - new Date(a.dateInvited)
        })
    }

    const filters = useMemo(() => [
        !isManager && {
            id: "school",
            label: "School",
            type: FilterTypeId.SelectDropDown,
            options: schools ? schools : [],
          },
        ], [schools])

    if(families.length > 0) {
    return (
        <div>
            <SearchHeader title= "Lesson Proposals" filters={filters} onChangeFilters={(filterState) => setFilterState(filterState)} clearAll={isManager ? false : true} />
            <div className='proposals-table__wrapper'>
                <table className='proposals-table'>
                    {filteredProposals.map((proposal, index) => (
                        <tr key={index} style={index % 2 ? {backgroundColor: '#fff'} : {backgroundColor: '#F8FAFC'}}>
                            <td className='proposals-table__name'>{proposal.teacherName}</td>
                            <td className='proposals-table__name'>{getFamilyName(proposal.familyId)}</td>
                            <td className='proposals-table__date'>{format(new Date(proposal.dateInvited), 'MM/dd/yy')}</td>
                            <td>{
                            proposal.interested && proposal.dateResponded ? 
                            <td className='proposals-table__chip'  style={{backgroundColor: '#CCFBF1', color: '#14B8A6'}}>Accepted</td> : 
                            <div>{proposal.dateResponded ? 
                            <td className='proposals-table__chip'  style={{backgroundColor: '#FEE2E2', color: '#EF4444'}}>Declined</td> 
                            : 
                            <td className='proposals-table__chip'  style={{backgroundColor: '#FFEDD5', color: '#F97316'}}>No Answer</td>
                            }
                            </div>
                        }</td>
                        <div>
                        <td className='proposals-table__chip'  style={{backgroundColor: '#F1F5F9', color: '#334155'}}>{proposal.offeredParentInstrument}</td>
                        </div>
                        </tr>
                    ))}
                </table>
            </div>
        </div>
    )
                } else {
                    return (
                        <div>
                            Loading...
                        </div>
                    )
                }
}
export default Proposals